<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  created () {
    console.log(`%c version %c ${process.env.VUE_APP_VERSION} %c`, 'background: #35495e; padding: 1px; border-radius: 2px 0 0 2px; color: #fff;', 'background: #409EFF; padding: 1px; border-radius: 0 2px 2px 0; color: #fff;', 'background: transparent;')
  }
}
</script>

<style lang="stylus">
body.area-limit
  background-color #230034

body.maintenance
  background-color #FFF

#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
</style>
